import script from "./PrintGoodLabelBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintGoodLabelBtn.vue?vue&type=script&lang=ts&setup=true"

import "./PrintGoodLabelBtn.vue?vue&type=style&index=0&id=5880959e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5880959e"]])

export default __exports__